import { Col, Row } from 'react-bootstrap';
import LabelRequired from '../../../../../../../../../../component/LabelRequired';
import ProvisonalDiagnosis from '../../../../../../../../../../phan-he-kham-benh/components/ProvisonalDiagnosis';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import clsx from 'clsx';

type Props = {
	rowClassName?: string;
	containerClassName?: string;
	endRowClassName?: string;
	labelAlign?: 'top' | 'left';
	isView?: boolean;
};

const ChanDoan = ({
	rowClassName,
	containerClassName,
	endRowClassName,
	labelAlign = 'left',
	isView = false,
}: Props) => {
	const { values, errors, touched, setValues, setFieldValue } = useFormikContext<any>();

	const [listComorbidity, setListComorbidity] = useState();

	return (
		<Row className="spaces pt-10">
			<Col sm={2}>
				<LabelRequired
					label="Chẩn đoán"
					className={clsx({
						'spaces pl-8': labelAlign === 'top',
					})}
				/>
			</Col>
			<Col sm={labelAlign === 'left' ? 10 : 12} className="p-0">
				<Row
					className={clsx(
						'flex-1 position-relative w-100 spaces pl-10',
						containerClassName
					)}
				>
					<ProvisonalDiagnosis
						encounterDiagnosisValues={values}
						encounterDiagnosisErrors={errors}
						encounterDiagnosisTouched={touched}
						listComorbidity={listComorbidity}
						setListComorbidity={setListComorbidity}
						onChange={(data: any) =>
							setValues({
								...values,
								...data,
							})
						}
						handleChangeEncounterDiagnosis={setFieldValue}
						rowClassName={clsx(rowClassName)}
						endRowClassName={endRowClassName}
						disabled={isView}
					/>
				</Row>
			</Col>
		</Row>
	);
};

export default ChanDoan;
